import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UserProfileService } from '../../users/services/user-profile.service';
import {DecimalPipe} from "@angular/common";

@Pipe({
  name: 'unitsConversion'
})
export class UnitsConversionPipe implements PipeTransform {
  constructor(
    private userProfileService: UserProfileService,
    private decimalPipe: DecimalPipe
  ) {

  }
  transform(value : any, unit: string | null, type: string): any {
    switch (type) {
      case 'speed':
        unit = unit ||  this.userProfileService.getProfile('nomad.noc.ng.units');
        const units = environment && environment.systemUnits;
        const metric = units && units.items && units.items.find(item => item.metric === unit);
        if((metric && metric.metric) === 'imperial') {
          value = value / 1.609;
        }
          return metric && `${this.decimalPipe.transform(value, "1.2-2")} ${metric.symbol}`
        }
    }
}